import styled from "styled-components";

export const AuditViewColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;

export const AuditEditWrapper = styled.div`
  display: flex;
  align-self: flex-start;
  flex-direction: row;
  padding-top: 8px;
`;

export const AuditTimestampWrapper = styled.div`
  align-self: flex-start;
  flex-grow: 1;
  display: contents;
`;

export const TimestampEditHeader = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  font-style: normal;
  align-self: flex-end;
  flex-grow: 1;
  order: 2;
`;

export const UserTypeHeader = styled.div`
  font-family: Inter;
  font-weight: ${({ theme }) => theme.typography.font250.fontWeight};
  font-size: ${({ theme }) => theme.typography.font250.fontSize};
  line-height: ${({ theme }) => theme.typography.font250.lineHeight};
  font-style: normal;
  align-self: flex-start;
  flex-grow: 1;
  order: 1;
  padding: 0 1rem 0 0;
`;

export const NoEditsHeader = styled.div`
  color: #55565f;
  font-family: Inter;
  font-weight: ${({ theme }) => theme.typography.font300.fontWeight};
  font-size: ${({ theme }) => theme.typography.font300.fontSize};
  line-height: ${({ theme }) => theme.typography.font300.lineHeight};
  font-style: italic;
`;

// New components for redesigned audit trail

export const SectionCard = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: ${({ theme }) => theme.sizing.scale550};
  padding: ${({ theme }) => theme.sizing.scale300};
  border-bottom: 1.5px solid ${({ theme }) => theme.colorTokens.gray200};
  margin-bottom: ${({ theme }) => theme.sizing.scale600};
`;

export const IconColumn = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const IconPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colorTokens.gray200};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.typography.font450.fontSize};
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.scale300};
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionTitle = styled.div<{ deleted?: boolean }>`
  font-family: ${({ theme }) => theme.typography.font300.fontFamily};
  font-weight: 600;
  font-size: ${({ theme }) => theme.typography.font300.fontSize};
  /* line-height: ${({ theme }) => theme.typography.font300.lineHeight}; */
  color: ${({ theme, deleted }) => (deleted ? theme.colorTokens.red400 : theme.colorTokens.black)};
`;

export const SectionSubtitle = styled.div<{ deleted?: boolean }>`
  font-family: ${({ theme }) => theme.typography.font250.fontFamily};
  font-weight: ${({ theme }) => theme.typography.font250.fontWeight};
  font-size: ${({ theme }) => theme.typography.font250.fontSize};
  line-height: ${({ theme }) => theme.typography.font250.lineHeight};
  color: ${({ theme, deleted }) => (deleted ? theme.colorTokens.red400 : theme.colorTokens.black)};
`;

export const ArrowIcon = styled.img`
  padding-inline: 1em;
`;

export const TimestampRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.scale300};
`;

export const ChangeHistoryLink = styled.div`
  font-family: ${({ theme }) => theme.typography.font200.fontFamily};
  font-weight: ${({ theme }) => theme.typography.font200.fontWeight};
  font-size: ${({ theme }) => theme.typography.font200.fontSize};
  line-height: ${({ theme }) => theme.typography.font200.lineHeight};
  color: ${({ theme }) => theme.colorTokens.blue400};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.scale100};
  margin-top: ${({ theme }) => theme.sizing.scale100};

  &:hover {
    text-decoration: underline;
  }
`;

export const HistoryItem = styled.div<{ deleted?: boolean }>`
  padding-top: ${({ theme }) => theme.sizing.scale400};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.scale300};

  ${({ theme, deleted }) =>
    deleted &&
    `
    color: ${theme.colorTokens.red400};
  `}
`;

export const HistoryItemTitle = styled.div<{ deleted?: boolean }>`
  font-family: ${({ theme }) => theme.typography.font200.fontFamily};
  font-weight: bold;
  font-size: ${({ theme }) => theme.typography.font200.fontSize};
  line-height: ${({ theme }) => theme.typography.font200.lineHeight};
  color: ${({ theme, deleted }) => (deleted ? theme.colorTokens.red400 : theme.colorTokens.black)};
`;

export const HistoryItemDate = styled.span`
  font-family: ${({ theme }) => theme.typography.font250.fontFamily};
  font-weight: normal;
  font-size: ${({ theme }) => theme.typography.font250.fontSize};
  line-height: ${({ theme }) => theme.typography.font250.lineHeight};
  color: ${({ theme }) => theme.colorTokens.gray500};
  margin-left: ${({ theme }) => theme.sizing.scale300};
`;

export const DeletedTimestamp = styled.span`
  text-decoration: line-through;
`;

export const TimestampPairWrapper = styled.div<{ deleted?: boolean }>`
  display: flex;
  gap: ${({ theme }) => theme.sizing.scale300};
  align-items: center;

  ${({ deleted }) =>
    deleted &&
    `
    text-decoration: line-through;
  `}
`;

export const WarningWrapper = styled.div`
  display: block;
  text-align: center;
  height: 152px;
  width: 410px;
  margin-top: 12px;
  padding-top: 24px;
  top: 0px;
  background-color: #e72e3e12;
  padding-bottom: 0px;
  border-radius: 8px;
`;

export const WarningMessage = styled.div`
  text-align: center;
  color: #e72e3e;
  font-family: "Inter";
  font-style: normal;
  font-weight: ${({ theme }) => theme.typography.font350.fontWeight};
  font-size: ${({ theme }) => theme.typography.font350.fontSize};
  line-height: ${({ theme }) => theme.typography.font350.lineHeight};
  margin-top: 8px;
`;

export const TriageMessage = styled.div`
  text-align: center;
  color: #33343d;
  font-family: "Inter";
  font-weight: ${({ theme }) => theme.typography.font200.fontWeight};
  font-size: ${({ theme }) => theme.typography.font200.fontSize};
  line-height: ${({ theme }) => theme.typography.font200.lineHeight};
  font-style: normal;
  margin-top: 8px;
`;

export const AuditTrailScrollableContainer = styled.div`
  max-height: 425px;
  overflow-y: auto;
  overflow-x: visible;
  position: relative;

  /* Smooth scrolling */
  scroll-behavior: smooth;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colorTokens.gray100};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colorTokens.gray400};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colorTokens.gray500};
  }
`;
